import { render, staticRenderFns } from "./RiskDetail.vue?vue&type=template&id=209eb64e&scoped=true"
import script from "./RiskDetail.vue?vue&type=script&lang=js"
export * from "./RiskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209eb64e",
  null
  
)

export default component.exports